import countries from 'i18n-iso-countries'
import { includes } from 'lodash-es'
import { LocalisationStore } from 'utils/localisation'

interface IIsoCountryServiceProps {
  localisationStore: LocalisationStore
}

export type LocalisedCountry = {
  code: string
  name: string
}

export class IsoCountryService {
  localisationStore: LocalisationStore
  countries = countries
  constructor(props: IIsoCountryServiceProps) {
    this.localisationStore = props.localisationStore
    this.configureCountriesIso = this.configureCountriesIso.bind(this)
    this.getCountryNameFromCode = this.getCountryNameFromCode.bind(this)
    this.filterCountryNames = this.filterCountryNames.bind(this)

    this.configureCountriesIso()
  }

  configureCountriesIso() {
    this.localisationStore.availableLanguages
      .map((language) => language.code)
      .forEach((countryCode) => {
        this.countries.registerLocale(
          // eslint-disable-next-line import/no-dynamic-require, global-require
          require(`i18n-iso-countries/langs/${countryCode}.json`)
        )
      })
  }

  getAllCountries() {
    return this.countries.getNames(this.localisationStore.current)
  }

  getCountryNameFromCode(code: string) {
    return this.countries.getName(code, this.localisationStore.current)
  }

  getCodeFromCountryName(countryName: string): string {
    return this.countries.getAlpha2Code(countryName, this.localisationStore.current) ?? 'DE'
  }

  filterCountryNames(substr: string): LocalisedCountry[] {
    const searchString = (substr || '').toLowerCase()
    const countriesObject = this.countries.getNames(this.localisationStore.current)

    const matchedCountries = Object.keys(countriesObject)
      .map((countryCode) => {
        const countryName = countriesObject[countryCode]

        if (countryName && !includes(countryName.toLowerCase(), searchString)) {
          return {
            code: countryCode,
            position: -1,
          }
        }
        return {
          code: countryCode,
          position: countryName.toLowerCase().search(searchString),
          name: countryName,
        }
      })
      .filter((country) => country.position >= 0)

    return matchedCountries
      .sort((countryA, countryB) => {
        const positionMatchDiff = countryA.position - countryB.position

        if (positionMatchDiff) {
          return positionMatchDiff
        }

        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        return countryA.name > countryB.name ? 1 : -1
      })
      .map((country) => {
        return {
          code: country.code,
          name: countriesObject[country.code],
        }
      })
  }
}
